import { createClient } from "@sanity/client";

const client = createClient({
  projectId: "yjk5h6gn",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-09-09",
});


export default client;
